export default {
  CommitmentAdjust: 'Điều chỉnh cam kết chi',
  TotalAmountText: 'Tổng tiền',
  GeneralInfo: 'Thông tin chung',
  AdjustCommitRefNo: 'Số CKC điều chỉnh',
  AdjustCommitRefNoTooltip: 'Số cam kế chi điều chỉnh',
  ContractNo: 'Hợp đồng thực hiện',
  AccountedInformation: 'Thông tin đã hạch toán',
  RequiredInformation: 'Thông tin đề nghị',
  ProviderBankAccount: 'Tài khoản NCC',
  ProviderBankAccountTooltip: 'Tài khoản nhà cung cấp',
  ProviderBankName: 'Tên ngân hàng NCC',
  ProviderBankNameTooltip: 'Tên ngân hàng nhà cung cấp',
  ReferenceDate: 'Ngày đề nghị ĐC CKC',
  ReferenceDateTooltip: 'Ngày đề nghị điều chỉnh cam kểt chi',
  PostedDate: 'Ngày KBNN ghi sổ',
  PostedDateTooltip: 'Ngày kho bạc nhà nước ghi sổ',
  CommitmentAdjustRefNo: 'Số phiếu điều chỉnh',
};
